export enum ShippingType {
  All = 'ALL',
  Shipper = 'SHIPPER',
  Receiver = 'RECEIVER'
}
